import React from "react"
import NavigationItem from "./NavigationItem/NavigationItem"
import { imageConstants } from "../../../../../constants/image.constants"
import Image from "../../../../UI/Image/Image"
import PropTypes from "prop-types"
import * as styles from "./Navigation-tw-styles"
import LanguageSelection from "../../LanguageSelection/LanguageSelection"

const Navigation = ({
  navigation,
  isMobileNavOpen,
  toggleMobileNav,
  variant,
  language,
  isActive,
  languageSelection
}) => {
  const style = language=="en" ? styles[variant] : styles.defaultStyle
  const {
    navContainer,
    navItems,
    navContent,
    navToggle,
    navToggleIcon,
    navgationItem,
  } = style
  const renderNavigationItems = () => (
    <div className={navContent}>
      <ul className={navItems}>
        {navigation?.length > 0 &&
          navigation.map((item, index) => (
            <NavigationItem item={item} key={index} className={navgationItem} toggleMobileNav={toggleMobileNav} isActive={item?.link?.url.includes(isActive)?"active:text-lighteshtBlue":""} />
          ))}
      </ul>
      {languageSelection?.languagesCollection ? <LanguageSelection languages={languageSelection?.languagesCollection?.items} /> : <></>}
    </div>
  )
  return (
    <div className={navContainer}>
      {isMobileNavOpen && renderNavigationItems()}
      <div className={navToggle}>
        {/* <span
          className={`uppercase mr-[5px] text-[21px] text-darkBlue hidden`}
          onClick={toggleMobileNav}
        >
        </span> */}
        <Image
          contentfulImage={
            isMobileNavOpen ? imageConstants?.mobileNavToggleClose : imageConstants.mobileNavToggleNew
          }
          className={navToggleIcon}
          onClick={toggleMobileNav}
        />
      </div>
    </div>
  )
}

Navigation.propTypes = {
  navigation: PropTypes.array,
  isMobileNavOpen: PropTypes.bool,
  toggleMobileNav: PropTypes.func,
  variant: PropTypes.string,
  language: PropTypes.string,
  isActive: PropTypes.string,
  languageSelection: PropTypes.object
}

export default Navigation
